export const GET_BAGGAGE_DISCOUNT_CODES = 'GET_BAGGAGE_DISCOUNT_CODES';
export const FLAG_GETTING_BAGGAGE_DISCOUNT_CODES = 'FLAG_GETTING_BAGGAGE_DISCOUNT_CODES';
export const CLEAR_BAGGAGE_DISCOUNT_CODES = 'CLEAR_BAGGAGE_DISCOUNT_CODES';

export const GET_SPECIAL_BAGGAGE_DISCOUNT_CODES = 'GET_SPECIAL_BAGGAGE_DISCOUNT_CODES';
export const FLAG_GETTING_SPECIAL_BAGGAGE_DISCOUNT_CODES =
  'FLAG_GETTING_SPECIAL_BAGGAGE_DISCOUNT_CODES';
export const CLEAR_SPECIAL_BAGGAGE_DISCOUNT_CODES =
  'CLEAR_SPECIAL_BAGGAGE_DISCOUNT_CODES';